import React from "react";
import { useSettings } from "../context/SettingsContext";

const WhatsAppIcon = (props) => (
  <svg width="26" height="26" viewBox="0 0 32 32" fill="white" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16.001 3C9.373 3 4 8.373 4 15c0 2.383.687 4.6 1.87 6.472L4 29l7.67-1.837A11.94 11.94 0 0 0 16 27c6.628 0 12-5.373 12-12S22.628 3 16.001 3Zm0 21.6c-1.723 0-3.34-.464-4.73-1.273l-.339-.198-4.554 1.09 1.113-4.435-.221-.354A9.554 9.554 0 0 1 6.4 15c0-5.29 4.31-9.6 9.6-9.6s9.6 4.31 9.6 9.6-4.31 9.6-9.6 9.6Zm5.494-7.19c-.301-.15-1.783-.88-2.06-.98-.276-.1-.478-.15-.68.15-.2.301-.78.98-.955 1.18-.176.2-.351.226-.652.075-.301-.15-1.271-.469-2.421-1.495-.895-.799-1.5-1.786-1.676-2.087-.176-.301-.019-.464.132-.614.135-.135.301-.351.451-.527.15-.176.2-.3.301-.501.1-.2.05-.376-.025-.526-.075-.15-.68-1.638-.93-2.239-.245-.588-.494-.508-.68-.518l-.58-.01c-.2 0-.526.075-.803.376-.276.301-1.054 1.03-1.054 2.515s1.079 2.918 1.229 3.119c.15.2 2.12 3.239 5.14 4.538.718.311 1.279.497 1.715.635.72.229 1.375.197 1.894.12.578-.087 1.783-.729 2.033-1.432.25-.703.25-1.305.175-1.432-.075-.126-.276-.201-.577-.351Z" />
  </svg>
);

const TelegramIcon = (props) => (
  <svg width="26" height="26" viewBox="0 0 32 32" fill="white" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M25.515 6.1 3.79 14.538c-1.485.599-1.475 1.43-.272 1.798l5.577 1.738 12.902-8.14c.61-.371 1.167-.171.71.235l-10.454 9.437h-.002l.002.001-.385 5.75c.564 0 .813-.259 1.13-.564l2.717-2.645 5.63 4.156c1.037.573 1.784.279 2.043-.964l3.696-17.415c.378-1.518-.582-2.206-1.573-1.826Z" />
  </svg>
);

export default function FloatingChatButton() {
  const { settings } = useSettings();
  const channel = settings.primary_chat_channel || "telegram";
  if (channel === "none") return null;

  let href = "";
  let bg = "";
  let ping = "";
  let Icon = null;
  let label = "";

  if (channel === "whatsapp") {
    const num = (settings.whatsapp_number || "").replace(/[^0-9]/g, "");
    if (!num) return null;
    const msg = encodeURIComponent(settings.whatsapp_message || "Hi Aducation");
    href = `https://wa.me/${num}?text=${msg}`;
    bg = "from-emerald-500 to-emerald-600";
    ping = "bg-emerald-500 shadow-emerald-500/40";
    Icon = WhatsAppIcon;
    label = "Chat on WhatsApp";
  } else {
    const uname = (settings.telegram_username || "").replace(/^@/, "").trim();
    if (!uname) return null;
    href = `https://t.me/${uname}`;
    bg = "from-sky-500 to-blue-600";
    ping = "bg-sky-500 shadow-sky-500/40";
    Icon = TelegramIcon;
    label = "Chat on Telegram";
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-chat-btn"
      data-channel={channel}
      aria-label={label}
      className="fixed bottom-5 right-5 z-40 group"
    >
      <div className="relative">
        <span className={`absolute inset-0 rounded-full ${ping} animate-ping opacity-40`} />
        <div className={`relative w-14 h-14 rounded-full bg-gradient-to-br ${bg} flex items-center justify-center shadow-2xl group-hover:scale-110 transition`}>
          <Icon />
        </div>
      </div>
    </a>
  );
}
